<template>
  <div class="display-2 primary--text text-xs-right">{{ value | numberFormat }}</div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/OverviewCounter.vue